import { useScopedTranslate } from '@locale/translate';

import { useFlowNodes } from 'ui/journey-builder/hooks/use-nodes';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

type ActionType = 'send_sms';

export const Node = (node: JourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);
  useFlowNodes();

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard node={node} label={t('title')}>
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
};

const nodeLocale = {
  en: {
    title: 'Send SMS',
    description: 'Sends an SMS',
  },
};
